var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"prominent":"","type":_vm.type}},[_c('v-layout',{attrs:{"align-center":"","wrap":""}},[_c('div',[_vm._v(_vm._s(_vm.$t(_vm.text)))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }